export default __webpack_public_path__ + "static/media/light-blue-diamond-icon.228076c2.svg";